import type { ReactNode } from "react";
import { Check } from "lucide-react";

export function ConsentCheckbox({
  checked,
  disabled,
  onChange,
  testId,
  children,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
  testId: string;
  children: ReactNode;
}) {
  return (
    <label className="flex items-start gap-2 text-xs text-ink">
      <span className="tktic-consent-checkbox-shell">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          data-testid={testId}
          className="tktic-consent-checkbox"
        />
        <Check
          aria-hidden="true"
          className="tktic-consent-checkbox-check"
          strokeWidth={2.5}
        />
      </span>
      <span className="leading-5">{children}</span>
    </label>
  );
}
